module.exports = "/images/integrations.svg?029369312359ce4641238da63edf677b";